import styles from '../styles/app.module.css';

interface Props {
  disabled?: boolean;
  onClick(): void;
}

export function CameraFlipButton({ disabled, onClick }: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label="Flip camera"
      className={styles.topIconButton}
    >
      ⇄
    </button>
  );
}
